import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl as MuiFormControl, FormHelperText as MuiFormHelperText, FormLabel as MuiFormLabel, RadioGroup as MuiRadioGroup, } from '@mui/material';
import { forwardRef, useCallback, } from 'react';
import { styled } from '../../utils';
import { Radio } from '../Radio';
import { Typography } from '../Typography';
export const RadioGroup = forwardRef(function RadioGroup(props, ref) {
    const { onChange, options, label, labelVariant, EndDecorator, emptyEndDecorator, required, error, helperText, disabled, direction, ...otherProps } = props;
    const handleChange = useCallback((event, newValue) => {
        if (onChange === undefined) {
            return;
        }
        if (options === undefined) {
            return;
        }
        const idx = Number.parseInt(newValue);
        const { value } = options[idx];
        onChange(value);
    }, [onChange, options]);
    return (_jsxs(MuiFormControl, { component: "fieldset", fullWidth: true, children: [!!label && (_jsx(FormLabelStyled, { error: error, component: "legend", children: label && (_jsxs(Typography, { variant: labelVariant ?? 'inherit', color: otherProps.color, children: [label, required && '\xa0*'] })) })), _jsx(RadioGroupStyled, { ref: ref, onChange: handleChange, ...otherProps, sx: { flexDirection: direction }, children: (options || []).map((option, idx) => (_jsx(Radio, { emptyEndDecorator: emptyEndDecorator, endDecorator: EndDecorator && _jsx(EndDecorator, { ...option }), labelClass: option.className, checked: option.value === props.value, label: option.label, value: idx, disabled: option.disabled || disabled }, option.value))) }), helperText && (_jsx(MuiFormHelperText, { error: error, children: helperText }))] }));
});
const FormLabelStyled = styled(MuiFormLabel, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
    color: error ? theme.palette.error.main : 'inherit',
    marginBottom: theme.spacing(1.5),
}));
const RadioGroupStyled = styled(MuiRadioGroup)(({ theme }) => ({
    gap: theme.spacing(1),
}));
